import React from 'react'

import { Table } from '_zari/core'

import { DateHandler } from 'utils'

import RowTemplate from './row'

const DetallesTablaSection = ({ fechaSeleccionada, tiposCambio }) => {
  const splitedFechaSeleccionada = React.useMemo(() => {
    const parsedFechaSeleccionada = DateHandler.parse(fechaSeleccionada)
    const splitedParse = {
      dia: parsedFechaSeleccionada.getDate(),
      mes: parsedFechaSeleccionada.getMonth(),
      anio: parsedFechaSeleccionada.getFullYear()
    }

    const fechaCalculoDiasxMes = new Date(splitedParse.anio, splitedParse.mes + 1, 0)
    const cantidadDiasxMes = fechaCalculoDiasxMes.getDate()

    // const fechaHoy = new Date()
    // const splitedHoy = {
    //   dia: fechaHoy.getDate(),
    //   mes: fechaHoy.getMonth(),
    //   anio: fechaHoy.getFullYear()
    // }

    const cantidadDias = cantidadDiasxMes

    return {
      cantidadDias,
      mes: splitedParse.mes + 1,
      anio: splitedParse.anio
    }
  }, [fechaSeleccionada])

  const filas = React.useMemo(() => {
    const output = []

    for (let i = 0; i < splitedFechaSeleccionada.cantidadDias; i++) {
      const validDia = i + 1

      const matchedTipoCambio = tiposCambio.find(x => x.dia === validDia)

      output.push({
        fecha: `${validDia}${DateHandler._DIVIDERSYMBOL}${splitedFechaSeleccionada.mes}${DateHandler._DIVIDERSYMBOL}${splitedFechaSeleccionada.anio}`,
        anio: splitedFechaSeleccionada.anio,
        mes: splitedFechaSeleccionada.mes,
        dia: validDia,
        precioCompraDolares: matchedTipoCambio ? matchedTipoCambio.precioCompraDolares : '',
        precioVentaDolares: matchedTipoCambio ? matchedTipoCambio.precioVentaDolares : '',
        precioCompraEuros: matchedTipoCambio ? matchedTipoCambio.precioCompraEuros : '',
        precioVentaEuros: matchedTipoCambio ? matchedTipoCambio.precioVentaEuros : ''
      })
    }

    return output
  }, [splitedFechaSeleccionada, tiposCambio])

  return (
    <Table
      headRows={[
        { label: 'FECHA', width: 65, align: 'center' },
        { label: 'COMP EUR', width: 70 },
        { label: 'VENT EUR', width: 70 },
        { label: '', width: 80 }
      ]}
      maxRowsShown={5}
      filas={filas}
      rowTemplate={(row, k) => <RowTemplate key={k} rowInfo={row} />}
    />
  )
}

export default React.memo(DetallesTablaSection)
